<form nz-form [formGroup]="claimFilterForm">
    <div nz-row gutter="16" style="display: flex; flex-wrap: wrap; align-items: flex-end; width: 100%">
        @if(claimFilterForm.controls['timeframe']){
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control style="width: 100%;">
                    <div style="width: 100%;" class="filters">
                        <ppl-dropdown-select formControlName="timeframe" id="timeframe" placeholder="Time Frame"
                            [options]="timeframeOptions" [optionLabel]="'label'" [optionValue]="'value'">
                        </ppl-dropdown-select>
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        @if(claimFilterForm.controls['serviceCode']){
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control style="width: 100%;">
                    <div style="width: 100%;" class="filters">
                        <ppl-dropdown-select formControlName="serviceCode" id="serviceCode" placeholder="Service Code"
                            [options]="serviceCodes" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
                        </ppl-dropdown-select>
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div> }
        @if(claimFilterForm.controls['serviceDate']){
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control style="width: 100%;">
                    <div style="width: 100%;" class="filters">
                        <nz-date-picker formControlName="serviceDate" [id]="'serviceDate'" style="height: 32px;"
                            [nzFormat]="'MM/dd/yyyy'" [nzPlaceHolder]="'Service Date'"></nz-date-picker>
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        @if(claimFilterForm.controls['modifierCode']){
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control>
                    <input nz-input type="text" formControlName="modifierCode" placeholder="Modifier Code"
                        class="custom-input" />
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        @if(claimFilterForm.controls['participantPplId']){
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control>
                    <input nz-input type="text" formControlName="participantPplId" placeholder="Consumer PPL ID"
                        class="custom-input" />
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        @if(claimFilterForm.controls['pplIcn']){
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control>
                    <input nz-input type="text" formControlName="pplIcn" placeholder="PPL ICN" class="custom-input" />
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        @if(claimFilterForm.controls['mco']){
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control style="width: 100%;">
                    <div style="width: 100%;" class="filters">
                        <ppl-dropdown-select formControlName="mco" id="mco" placeholder="MCO" [options]="mcoEntries"
                            [optionLabel]="'orgName'" [optionValue]="'orgName'">
                        </ppl-dropdown-select>
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div> }
        @if(claimFilterForm.controls['authNumber']){
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control>
                    <input nz-input type="text" formControlName="authNumber" placeholder="Auth Number"
                        class="custom-input" />
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        @if(claimFilterForm.controls['batchFileTypeLkp']){
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control style="width: 100%;">
                    <div style="width: 100%;" class="filters">
                        <ppl-dropdown-select formControlName="batchFileTypeLkp" id="batchFileTypeLkp"
                            placeholder="Adjustment Type" [options]="fileTypeList" [optionLabel]="'label'"
                            [optionValue]="'value'">
                        </ppl-dropdown-select>
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div> }
        <div nz-col [nzSpan]="12" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="text-align: right; margin-left: 8px;margin-top: 8px;">
            <nz-form-item>
                <ppl-button label="Search" icon="fa fa-filter" style="margin-top: -2px;" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="search()"></ppl-button>
            </nz-form-item>
        </div>
        @if (adjustType === 'bulk') {
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
        style="margin-left: -6rem;">
            <nz-form-item>
                <ppl-button label="" ariaLabel="Refresh" icon="fa fa-refresh" [customClass]="'primary-button'"
                    [iconPosition]="'left'" (click)="refresh()"></ppl-button>
            </nz-form-item>
        </div>
        }
    </div>
    @if(showFilterError){
    <div class="alert alert-danger" style="margin-top: 24px;" role="alert"><strong>Error:</strong> Please enter Consumer
        PPL ID or PPL ICN. </div>
    }

</form>